import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";

const PaymentOptions = ({ handleInputChangePaymentMethod, t }) => {
  const [selectedPayment, setSelectedPayment] = useState(1);

  const handleChange = (value) => {
    setSelectedPayment(value);
    handleInputChangePaymentMethod(value);
  };

  return (
    <div>
      {/* <Accordion
        expanded={selectedPayment === 2}
        onChange={() => handleChange(2)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className="payment-methods-title"
        >
          <FormControlLabel
            className="payment-methods-title-h5"
            value="2"
            control={
              <Radio
                checked={selectedPayment === 2}
                onChange={() => handleChange(2)}
              />
            }
            label={"Plaćanje karticama"}
          />
        </AccordionSummary>
        <AccordionDetails className="payment-methods-accordion-detail">
          <Typography>
            <div className="payment-methods-description">
              Plaćajte najčešće korišćenim kreditnim i debitnim karticama.
            </div>
          </Typography>
        </AccordionDetails>
      </Accordion> */}

      <Accordion
        expanded={selectedPayment === 1}
        onChange={() => handleChange(1)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className="payment-methods-title"
        >
          <FormControlLabel
            className="payment-methods-title-h5"
            value="1"
            control={
              <Radio
                checked={selectedPayment === 1}
                onChange={() => handleChange(1)}
              />
            }
            label={"Pouzećem"}
          />
        </AccordionSummary>
        <AccordionDetails className="payment-methods-accordion-detail">
          <Typography>
            <div className="payment-methods-description">
              Plaćanje kuriru po preuzimanju robe. Plaćanje se vrši isključivo
              gotovinom.
            </div>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default PaymentOptions;
